import { render } from "./updateAdmin.vue?vue&type=template&id=60e5922a&scoped=true"
import script from "./updateAdmin.vue?vue&type=script&lang=js"
export * from "./updateAdmin.vue?vue&type=script&lang=js"

import "./updateAdmin.vue?vue&type=style&index=0&id=60e5922a&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e5922a"]])

export default __exports__